export const executeParallelBatches = async <T>(
    tasks: (() => Promise<T>)[],
    batchSize: number,
    callback?: (results: T) => void,
) => {
    const batchesTotal = Math.ceil(tasks.length / batchSize);
    const results: T[][] = [];
    for (let batchNum = 0; batchNum < batchesTotal; batchNum++) {
        const batchedTasks = tasks.splice(0, batchSize);
        const promises: Promise<T>[] = [];

        for (const task of batchedTasks) {
            promises.push(task());
        }

        const batchResults = await Promise.all(promises);
        results.push(batchResults);
        for (const result of batchResults) {
            callback?.(result);
        }
    }
    return results.flat();
};

export function debounce<T extends (...args: any[]) => any>(
    func: T,
    wait: number,
): (...args: Parameters<T>) => void {
    let timeout: NodeJS.Timeout;

    return (...args: Parameters<T>) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), wait);
    };
}
